export const INDEX_ROUTE = '';
//export const INDEX_ROUTE = '/cart'

export const API_BASE = 'https://ostapi.reallysimplestore.com/'; // 'https://api.reallysimplestore.com/v1.1/';

export const STRIPE_CLIENT_ID = 'ca_AQThC6TJwcgNyOxlu6JcVtl6KI5a3QZp'; // test mode
//export const STRIPE_CLIENT_ID = 'ca_AQTh0UVU08VZzRzP0pP4TulA3QOHt4KD'; // live mode

export const stripe_publishable_key = "pk_test_yzFDuxP1GTgaD2VZchqvGDa6"; // test
//export const stripe_publishable_key = "pk_live_1rOSbDhTKj8PzhwCHdikJI9Z"; // live


// WEBPACK FOOTER //
// ./src/config.js